import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
// import "../css/trackOrder.css";

const API = "https://api.mahal.qa/api/v1/orders";




const statusToStep = {
  PLACED: 0,
  ACCEPTED: 1,
  PACKED: 2,
  OUT_FOR_DELIVERY: 2,
  DELIVERED: 3,
  REJECTED: 0,
};

const TrackOrder = ({ orderId }) => {

  const { t, i18n } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const id = orderId || params.id;

  const [orderStatus, setOrderStatus] = useState("PLACED");
  const [currentStep, setCurrentStep] = useState(0);
  const [delivery, setDelivery] = useState(null);
  const [location, setLocation] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);


  const steps = [
    { label: t("restrack_placed"), icon: "fa-receipt" },
    { label: t("restrack_confirmed"), icon: "fa-circle-check" },
    { label: t("restrack_delivery"), icon: "fa-truck-fast" },
    { label: t("restrack_delivered"), icon: "fa-house-circle-check" },
  ];

  const formatArabicNumber = (value) => {
    if (i18n.language !== "ar") return value;

    return String(value).replace(/\d/g, (d) =>
      "٠١٢٣٤٥٦٧٨٩"[d]
    );
  };

  const formatOrderId = (id) => {
    if (i18n.language !== "ar") return id;

    return String(id).replace(/\d/g, (d) =>
      "٠١٢٣٤٥٦٧٨٩"[d]
    );
  };

  /* ================= FETCH ORDER ================= */
  const fetchOrder = async () => {
    try {

      const res = await axios.get(
        `${API}/restaurant/orders/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = res.data;

      const status = data?.header?.status || "PLACED";

      setOrderStatus(status);
      setCurrentStep(statusToStep[status] ?? 0);

      // delivery info from backend
      setDelivery(data.delivery || null);

    } catch (err) {
      console.log("Failed to fetch order", err);
    }
  };


  /* ================= FETCH LOCATION ================= */
  const fetchLocation = async () => {
    try {

      const res = await axios.get(`${API}/delivery/${id}/location`);
      const data = res.data;

      if (data?.current_lat != null && data?.current_lng != null) {

        setLocation({
          lat: parseFloat(data.current_lat),
          lng: parseFloat(data.current_lng),
        });

        setLastUpdate(new Date());
      }

    } catch (err) {
      console.log("Location fetch error", err);
    }
  };


  /* ================= AUTO REFRESH ================= */
  useEffect(() => {

    if (!id) return;

    fetchOrder();
    fetchLocation();

    const interval = setInterval(() => {
      fetchOrder();
      fetchLocation();
    }, 5000);

    return () => clearInterval(interval);

  }, [id]);


  const mapsLink =
    location && delivery?.dest_lat && delivery?.dest_lng
      ? `https://www.google.com/maps/dir/?api=1&origin=${location.lat},${location.lng}&destination=${delivery.dest_lat},${delivery.dest_lng}&travelmode=driving`
      : location
        ? `https://www.google.com/maps?q=${location.lat},${location.lng}`
        : null;


  return (
    <div className="dashboard_page">

      {/* HEADER */}
      <div className="page_header">
        <div>
          <h2>
            <i className="fa-solid fa-location-dot me-2" style={{ color: "rgb(22, 163, 74)" }}></i>
            {t("restrack_order")}
          </h2>
          <p>Stay Updated with your order status in real-time</p>
        </div>

        <button className="btn_add_item_v2" onClick={() => navigate(-1)}>
          <i className="fa fa-arrow-left me-2"></i>
          {t("resback")}
        </button>
      </div>


      {/* ORDER INFO */}



      <div className="card modern_track_card">

        <div className="track_order_header">

          <div className="track_order_icon">
            <i className="fa-solid fa-clipboard-check"></i>
          </div>

          <div className="track_order_content">

            <h3 className="reference_id">
              Order id:{id}
            </h3>
            <div className="track_order_meta">

              <div className="meta_item">
                <i className="far fa-clock"></i>
                <span>Status:</span>

                <span className="track_status_badge">
                  <i className="fas fa-truck-fast"></i>

                  {
                    orderStatus === "PLACED"
                      ? t("resplaced")
                      : orderStatus === "ACCEPTED"
                        ? t("resaccepted")
                        : orderStatus === "PACKED"
                          ? t("respacked")
                          : orderStatus === "OUT_FOR_DELIVERY"
                            ? t("resout_for_delivery")
                            : orderStatus === "DELIVERED"
                              ? t("resdelivered")
                              : orderStatus
                  }
                </span>
              </div>

              <div className="meta_divider"></div>

              <div className="meta_item">
                <i className="far fa-clock"></i>
                <span>ETA:</span>
                <strong>
                  {delivery?.estimated_delivery_time
                    ? new Date(
                      delivery.estimated_delivery_time
                    ).toLocaleString(
                      i18n.language === "ar"
                        ? "ar-QA"
                        : "en-US"
                    )
                    : "--"}
                </strong>
              </div>

              <div className="meta_divider"></div>

              <div className="meta_item">
                <i className="fas fa-user"></i>
                <span>Driver:</span>

                <strong className="driver_not_assigned">
                  {delivery?.driver_name ||
                    delivery?.partner_name ||
                    t("resnot_assigned")}
                </strong>
              </div>

            </div>

          </div>


        </div>

        <div class="stat_card change_summary">

                    
          <div class="stat_content">
            <h3><i class="fa fa-cubes"></i>  Order Successfully Placed</h3>
            <p> We have received your order and are preparing it for you.</p>
          </div>
        </div>

      </div>

      {/* PROGRESS BAR */}
     <div className="track_progress_card">

  <div className="track_progress_header">
    <div className="track_progress_icon">
      <i className="fa-solid fa-chart-line"></i>
    </div>

    <div>
      <h5>{t("resorder_progress")}</h5>
      <p>Real-time updates on your order</p>
    </div>
  </div>

  <div className="track_stepper_wrapper">

    <div
      className="track_stepper_line_active"
      style={{
        width: `${(currentStep / (steps.length - 1)) * 100}%`,
      }}
    />

    <ul className="track_stepper">
      {steps.map((step, index) => (
        <li
          key={index}
          className={
            index < currentStep
              ? "completed"
              : index === currentStep
              ? "active"
              : ""
          }
        >
          <div className="track_step_circle">
            <i className={`fa-solid ${step.icon}`}></i>
          </div>

          <h6>{step.label}</h6>

          <small>
            {index === 0 && "Your order has been placed"}
            {index === 1 && "Shop has confirmed your order"}
            {index === 2 && "Your order is on the way"}
            {index === 3 && "Order delivered successfully"}
          </small>
        </li>
      ))}
    </ul>

  </div>

</div>


      {/* ACTIONS */}
      <div className="row mt-4">

        {/* SUPPORT / DRIVER CONTACT */}
        <div className="col-lg-4">
          <div className="card action_card">

            
              <div class="summary_item ">
                <i class="fa fa-headphones" aria-hidden="true"></i>
                <div>
                  <h4>{t("ressupport")}</h4>
                  <p>Need help sur support team is here for you</p>
                </div>
              </div>
            

            {delivery?.driver_mobile ? (
              <>
                <a
                  href={`tel:${delivery.driver_mobile}`}
                  className="btn btn-primary w-100 mb-2"
                >
                  <i className="fa-solid fa-phone me-2"></i>
                  {t("rescall_driver")}
                </a>

                <a
                  href={`https://wa.me/${delivery.driver_mobile}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-success w-100"
                >
                  <i className="fa-brands fa-whatsapp me-2"></i>
                  {t("reswhatsapp_driver")}
                </a>
              </>
            ) : (
              
              <div class=" alert alert-info summary_item">
              <i class="fa fa-user" aria-hidden="true"></i>
              <div>
              <h4>{t("resdriver_not_assigned")}</h4>
              <p>Need help sur support team is here for you</p>
              </div>
              </div>
              
            )}

            {mapsLink && (
              <a
                href={mapsLink}
                target="_blank"
                rel="noreferrer"
                className="btn btn-warning w-100 mt-2"
              >
                🧭 {t("resnavigate")}
              </a>
              
            )}
          
          </div>
        </div>


        {/* LIVE MAP */}
        <div className="col-lg-8">

          <div className="card">

            <div class="summary_item ">
<i 
  className="fa-solid fa-map-location-dot me-2" 
  style={{ backgroundColor: "rgb(234, 248, 234)", color: "rgb(22, 163, 74)" }}
></i>
<div>
<h5>{t("reslive_location")}</h5>
<p>Need help sur support team is here for you</p>
</div>
</div>

            {!location && (
              <div className="icon_map_placeholder">
                <i className="fa-solid fa-truck-moving"></i>
                <p>{t("reswaiting_driver_location")}</p>
              </div>
            )}

            {location && (

              <div style={{ height: "350px", width: "100%" }}>

                <iframe
                  key={`${location.lat}-${location.lng}`}
                  width="100%"
                  height="350"
                  style={{ border: 0 }}
                  loading="lazy"
                  allowFullScreen
                  src={
                    delivery?.dest_lat && delivery?.dest_lng
                      ? `https://maps.google.com/maps?saddr=${location.lat},${location.lng}&daddr=${delivery.dest_lat},${delivery.dest_lng}&output=embed`
                      : `https://maps.google.com/maps?q=${location.lat},${location.lng}&z=14&output=embed`
                  }
                ></iframe>

                {lastUpdate && (
                  <div className="last-update">
                    {t("reslast_updated")}: {lastUpdate.toLocaleTimeString(
                      i18n.language === "ar" ? "ar-QA" : "en-US"
                    )}
                  </div>
                )}

              </div>

            )}

          </div>

        </div>

      </div>

    </div>
  );
};

export default TrackOrder;